import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-reports',
  templateUrl: './client-reports.component.html',
  styleUrls: ['./client-reports.component.scss']
})
export class ClientReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
